"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryMarker = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
const Marker_1 = require("./Marker");
class GeometryMarker extends Marker_1.Marker {
    constructor(points, type, marker, map, name = "GeometryMarker", options) {
        super(0, 0, marker, map, name, options);
        this.points = [];
        this.leafletObject =
            type == "polygon" ? leaflet_1.default.polygon(points) : leaflet_1.default.polyline(points);
        this.geometryType = type;
        this.points = points;
        this.setActive(true);
    }
    setActive(isActive, force = false) {
        if (!this.leafletObject)
            return;
        if (isActive === this.isActive && !force)
            return;
        this.isActive = isActive;
        if (!this.map)
            return;
        if (this.isActive && this.isInitialized) {
            this.leafletObject.addTo(this.map);
            // @ts-ignore
            this.svgPathHtmlElement = this.leafletObject._path;
            this.svgPathHtmlElement.setAttribute("pointer-events", "auto");
            // Disable click propagation to leaflet map
            this.leafletObject.on("click", (e) => {
                this.callEventCallback("click", e);
                e.originalEvent.view.L.DomEvent.stopPropagation(e);
            });
            this.leafletObject.on("mouseover", (e) => {
                this.callEventCallback("mouseover", e);
                e.originalEvent.view.L.DomEvent.stopPropagation(e);
            });
            this.leafletObject.on("mouseout", (e) => {
                this.callEventCallback("mouseout", e);
                e.originalEvent.view.L.DomEvent.stopPropagation(e);
            });
        }
        else {
            if (this.isInitialized)
                this.leafletObject.removeFrom(this.map);
        }
        super.setActive(isActive, true);
        if (this.isActive) {
            // Save and set the center of the polygon
            const flatten = this.points.flat();
            this.recalculateLocation(flatten);
            // if(flatten.length > 0){
            //     flatten.forEach( (point: LocationPoint)=>{
            //         sum.lat += point[0];
            //         sum.lng += point[1];
            //     });
            //     sum.lat = sum.lat / flatten.length;
            //     sum.lng = sum.lng / flatten.length;
            // }
            // const center = sum;
            // this.marker.setLatLng(center);
            // this.location = [center.lat, center.lng];
        }
    }
    initialize() {
        const added = super.initialize();
        this.setActive(this.isActive, true);
        return this;
    }
    delete() {
        super.delete();
        this.leafletObject.removeFrom(this.map);
    }
    getPoints() {
        return this.points;
    }
    setPoints(points) {
        this.points = points;
        this.leafletObject.setLatLngs(points);
    }
    getLeafletObject() {
        return this.leafletObject;
    }
    setStyle(style) {
        this.leafletObject.setStyle(style);
    }
}
exports.GeometryMarker = GeometryMarker;
